export default "__VITE_ASSET__DvJqU2G$__"